export default {
  filterAlarmsButtonLabel: 'Filter alarms',
  filterTimeBucketLabel: 'Granularity',
  paretoOccurrences: 'Pareto: Occurrences',
  paretoDuration: 'Pareto: Alarm durations',
  table: 'Alarm Statistics',
  gantt: 'Timeline',
};
